import { theme } from '@maersktankersdigital/web-components'

export const breakpoints = {
  values: theme.values,
}
